import Nav from './sections/Nav';
import Hero from './sections/Hero';
import TrustStrip from './sections/TrustStrip';
import Capabilities from './sections/Capabilities';
import Features from './sections/Features';
import Privacy from './sections/Privacy';
import Pricing from './sections/Pricing';
import CtaBand from './sections/CtaBand';
import Footer from './sections/Footer';

export default function App(): JSX.Element {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <Capabilities />
        <Features />
        <Privacy />
        <Pricing />
        <CtaBand />
      </main>
      <Footer />
    </>
  );
}
